import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { CrudPage } from "@/components/crud/CrudPage";
import { EscalaEscalasTab } from "./EscalaEscalasTab";
import { EscalaGeradasTab } from "./EscalaGeradasTab";
import { EscalaRelatoriosTab } from "./EscalaRelatoriosTab";
import { EscalaColaboradoresTab } from "./EscalaColaboradoresTab";
import { EscalaFeriadosTab } from "./EscalaFeriadosTab";
import { EscalaAusenciasTab } from "./EscalaAusenciasTab";
import { EscalaCargasHorariasTab } from "./EscalaCargasHorariasTab";
import { EscalaPrazosTab } from "./EscalaPrazosTab";
import { EscalaParametrosTab } from "./EscalaParametrosTab";
import { EscalaIntegracaoArea } from "./EscalaIntegracaoArea";
import { EscalaPermissoesTab } from "./EscalaPermissoesTab";
import { useAdministradorEscala } from "@/hooks/useAdministradorEscala";
import { useGerenteDeEscala } from "@/hooks/useGerenteDeEscala";

// Nível principal: "Escalas" (cadastro, equipe e geração), "Escalas Geradas" (espelho, validar
// e aprovar) e "Relatórios" (Fase G — Gerente ou Administrador de Escala; a própria aba
// esconde o conteúdo pra quem não tem o papel) são o fluxo mensal, o que
// encarregado e gerente abrem o módulo pra fazer. "Configurações" reúne os cadastros de
// apoio, que se mexe uma vez e não de novo todo mês, em ordem de dependência: Colaboradores,
// Feriados, Ausências, Cargas Horárias, Prazos, Parâmetros, Integração externa e, por último,
// Permissões (vínculo de usuário a papel, não dado de escala). Loja é a company da plataforma,
// cadastrada só em /empresas. O papel é aplicado no backend por Method; a tela só esconde as abas
// que exigem Administrador de Escala (Cargas Horárias, Prazos, Parâmetros e Permissões) e a de
// Integração externa, que o Gerente também vê.
type EscalaTab = "escalas" | "escalas_geradas" | "relatorios" | "configuracoes";
type ConfigTab =
  | "colaboradores"
  | "feriados"
  | "ausencias"
  | "cargas_horarias"
  | "prazos"
  | "parametros"
  | "integracao"
  | "permissoes";

export function EscalaPage() {
  const [tab, setTab] = useState<EscalaTab>("escalas");
  const [configTab, setConfigTab] = useState<ConfigTab>("colaboradores");
  const { administrador } = useAdministradorEscala();
  const { podeVerRelatorios: gerente } = useGerenteDeEscala();
  const veIntegracao = administrador || gerente;

  return (
    <CrudPage title="Escala">
      <Tabs value={tab} onChange={(_, value: EscalaTab) => setTab(value)} sx={{ mb: 3 }}>
        <Tab label="Escalas" value="escalas" />
        <Tab label="Escalas Geradas" value="escalas_geradas" />
        <Tab label="Relatórios" value="relatorios" />
        <Tab label="Configurações" value="configuracoes" />
      </Tabs>

      {tab === "escalas" && <EscalaEscalasTab />}
      {tab === "escalas_geradas" && <EscalaGeradasTab />}
      {tab === "relatorios" && <EscalaRelatoriosTab />}

      {tab === "configuracoes" && (
        <Box>
          <Tabs
            value={configTab}
            onChange={(_, value: ConfigTab) => setConfigTab(value)}
            sx={{ mb: 3, borderBottom: 1, borderColor: "divider" }}
          >
            <Tab label="Colaboradores" value="colaboradores" />
            <Tab label="Feriados" value="feriados" />
            <Tab label="Ausências" value="ausencias" />
            {administrador && <Tab label="Cargas Horárias" value="cargas_horarias" />}
            {administrador && <Tab label="Prazos de Confecção" value="prazos" />}
            {administrador && <Tab label="Parâmetros" value="parametros" />}
            {veIntegracao && <Tab label="Integração externa" value="integracao" />}
            {administrador && <Tab label="Permissões" value="permissoes" />}
          </Tabs>

          {configTab === "colaboradores" && <EscalaColaboradoresTab />}
          {configTab === "feriados" && <EscalaFeriadosTab />}
          {configTab === "ausencias" && <EscalaAusenciasTab />}
          {administrador && configTab === "cargas_horarias" && <EscalaCargasHorariasTab />}
          {administrador && configTab === "prazos" && <EscalaPrazosTab />}
          {administrador && configTab === "parametros" && <EscalaParametrosTab />}
          {veIntegracao && configTab === "integracao" && <EscalaIntegracaoArea />}
          {administrador && configTab === "permissoes" && <EscalaPermissoesTab />}
        </Box>
      )}
    </CrudPage>
  );
}
